<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-users"></i>
          ຍອດພະນັກງານສາຂາ
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>
    </div>

    <div class="box">
      <div class="columns is-multiline is-mobile filter-section">
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-2-tablet is-2-desktop" style="margin-top: 3px">
          <vs-button
              ref="button" flat
              @click="exportData()"
              class="form-btn-loading"
              :loading="loading"
              :disabled="loading || hasPending || cooldown">
            export
          </vs-button>
        </div>
        <div class="column is-12-mobile is-2-tablet is-1-desktop" style="margin-top: 3px">
          <vs-button
              flat
              @click="FetchData()"
              :disabled="isLoading">
            <i class="fal fa-sync-alt"></i>
          </vs-button>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop" v-if="hasPending">
          <div class="field">
            <div class="control">
              <label class="label is-hidden-mobile">&nbsp;</label>
              <span class="has-text-warning">
                <i class="fal fa-spinner-third fa-spin"></i>
                ກຳລັງດຳເນີນການຢູ່
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ວັນທີສ້າງ</vs-th>
            <vs-th>ຊື່ໄຟລ໌</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="item"
              v-for="(item, index) in listExports">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ moment(item.created_at).format('DD-MM-YYYY HH:mm') }}</vs-td>
            <vs-td>{{ item.name }}</vs-td>
            <vs-td>{{ laStatus[item.status] || item.status }}</vs-td>
            <vs-td style="text-align: right; width: 100px">
              <div class="group-icon">
                <div v-if="item.status === 1">
                  <vs-button circle icon flat @click="download(item.id, item.name)">
                    <i class="fal fa-download"></i>
                  </vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/Pagination';
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  components: {
    Loading,
    pagination,
    DatePicker,
  },

  data: () => ({
    laStatus: {
      0: 'ກຳລັງດຳເນີນການ',
      1: 'ສຳເລັດ',
      2: 'ລົ້ມເຫຼວ',
    },
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    loading: false,
    cooldown: false,
    listExports: [],
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: {},
  }),

  computed: {
    hasPending() {
      return this.listExports.some(item => item.status === 0);
    },
  },

  methods: {
    moment,

    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    exportData() {
      const start = moment(this.start_date);
      const end = moment(this.end_date);
      const diffDays = end.diff(start, 'days');
      if (diffDays < 0) {
        this.$vs.notification({color: 'danger', position: 'top-right', title: 'ວັນທີບໍ່ຖືກຕ້ອງ', text: 'ວັນທີເລີ່ມຕ້ອງນ້ອຍກວ່າວັນທີສິ້ນສຸດ'});
        return;
      }
      if (diffDays > 31) {
        this.$vs.notification({color: 'danger', position: 'top-right', title: 'ໄລຍະເວລາເກີນ', text: 'ສາມາດເລືອກໄດ້ສູງສຸດ 31 ມື້'});
        return;
      }

      this.loading = true;
      this.$http.post('branch/employees/shipment/export', {
        start_date: this.start_date,
        end_date: this.end_date,
      }).then(() => {
        this.loading = false;
        this.cooldown = true;
        setTimeout(() => { this.cooldown = false; }, 5000);
        this.FetchData();
      }).catch((e) => {
        this.loading = false;
        if (e.response && e.response.status === 429) {
          const msg = e.response.data && e.response.data.error;
          if (msg && msg.includes('ສາຂາ')) {
            this.$vs.notification({color: 'warning', position: 'top-right', title: 'ກະລຸນາລໍຖ້າ', text: 'ສາຂານີ້ກຳລັງດຳເນີນການ export ຢູ່'});
          } else {
            this.$vs.notification({color: 'warning', position: 'top-right', title: 'ກະລຸນາລໍຖ້າ', text: 'ກຳລັງດຳເນີນການຢູ່'});
          }
        }
      });
    },

    download(id, filename) {
      this.$http.get(`branch/employees/shipment/export/download/${id}`, {responseType: 'blob'})
          .then((response) => {
            const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileUrl;
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
          }).catch((e) => {
            if (e.response && e.response.status === 404) {
              this.$vs.notification({color: 'warning', position: 'top-right', title: 'ໄຟລ໌ບໍ່ມີແລ້ວ', text: 'ໄຟລ໌ນີ້ຖືກລຶບແລ້ວ ກະລຸນາ export ໃໝ່'});
            } else {
              this.$vs.notification({color: 'danger', position: 'top-right', title: 'ເກີດຂໍ້ຜິດພາດ', text: 'ເກີດຂໍ້ຜິດພາດໃນການດາວໂຫລດ'});
            }
          });
    },

    FetchData() {
      this.isLoading = true;
      this.$http.get('branch/employees/shipment/exports', {
        params: {
          page: this.pagination.current_page,
          per_page: this.limit_page,
        }
      }).then((res) => {
        setTimeout(() => {
          this.listExports = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
  created() {
    this.FetchData();
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 40px;
}

.filter-section {
  align-items: flex-end;
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}
</style>
